<div class="reportListButton" id="reportListButton" *ngIf="_hasReportsWithPermissions">

    <!-- Botón principal para abrir el menú -->
    <button class="btnMore" mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Acciones" matTooltipPosition="above">
      <img src="/assets/img/icon_puntitos.png" width="25px">
    </button>

    <!-- Menú principal de acciones -->
    <mat-menu #menu="matMenu">
      <!-- se pasa al componente de botones de herramineta -->
      <!-- <button *ngIf="isGlobal" class="mat-button" mat-menu-item (click)="openFilter()">
        <mat-icon *ngIf="ApplyFilter">filter_alt_off</mat-icon>
        <mat-icon *ngIf="!ApplyFilter">filter_alt_on</mat-icon>
        <span>Filtro</span>
      </button> -->
      <!-- <button *ngIf="isDetailLocations" class="mat-button" mat-menu-item (click)="getLocationRoute()">
        <mat-icon>edit_location</mat-icon>
        <span>Trazabilidad de ruta</span>
      </button>
      <button *ngIf="isDetailLocations" class="mat-button" mat-menu-item (click)="ValetParking()">
        <mat-icon>play_for_work</mat-icon>
        <span *ngIf="!isValetParking">Activar valet parking</span>
        <span *ngIf="isValetParking">Desactivar valet parking</span>
      </button> -->
      <button *ngIf="reportes" class="mat-button" mat-menu-item [matMenuTriggerFor]="menuReportes" [disabled]="reportList.length == 0">
        <mat-icon>assignment_returned</mat-icon>
        <span>Reportes</span>
      </button>
            <!-- se pasa al componente de botones de herramineta -->
      <!-- <button *ngIf="btnDownExcel" class="mat-button" mat-menu-item (click)="getExcel()">
        <mat-icon>sim_card_download</mat-icon>
        <span>Descargar VINs</span>
      </button> -->
      <button *ngIf="editGeofences" class="mat-button" mat-menu-item [matMenuTriggerFor]="editAcciones" [disabled]="geofenceActionList.length == 0">
        <span>Acciones</span>
      </button>
      <button *ngIf="reportes" class="mat-button" mat-menu-item [matMenuTriggerFor]="menuGeoProcesos" [disabled]="geoprocessActionList.length == 0">
        <mat-icon>assignment_returned</mat-icon>
        <span>GeoProcesos</span>
      </button>
    </mat-menu>

    <!-- Menú secundario que se muestra al hacer hover sobre la opción de reportes -->
    <mat-menu #menuReportes="matMenu">
      <!-- Reportes para control llamado desde Control de Activos -->
      <button #globalL class="mat-button" mat-menu-item (click)="onClickDownloadReportHistGlobal()" *ngIf="isGlobal && 'Hist.Global-L' | permissionFilter">
        <img src="/assets/img/icon_download_xls.png" width="25px">
        <span>Hist. Global</span>
      </button>
      <button #movimientosL class="mat-button" mat-menu-item (click)="onClickReportMenuHistMov()" *ngIf="isFromLocation && 'Hist.Movimientos-L' | permissionFilter">
        <img src="/assets/img/icon_download_xls.png" width="25px">
        <span>Hist. de Movimientos</span>
      </button>
      <button #conduccionL class="mat-button" mat-menu-item (click)="onClickReportMenuHabit()" *ngIf="isFromLocation && 'Habit.Conduccion-L' | permissionFilter">
        <img src="/assets/img/icon_download_xls.png" width="25px">
        <span>Hábitos de Conducción</span>
      </button>
      <button #manejoL class="mat-button" mat-menu-item (click)="onClickReportMenuStats()" *ngIf="isFromLocation && 'Estad.Manejo-L' | permissionFilter">
        <img src="/assets/img/icon_download_xls.png" width="25px">
        <span>Estadisticos de Manejo</span>
      </button>

      <!-- Reportes para control llamado desde Rutas -->
      <button #movimientosR class="mat-button" mat-menu-item (click)="onClickReportMenuHistMov()" *ngIf="isRutas && 'Hist.Movimientos-R' | permissionFilter">
        <img src="/assets/img/icon_download_xls.png" width="25px">
        <span>Hist. de Movimientos</span>
      </button>
      <button #conduccionR class="mat-button" mat-menu-item (click)="onClickReportMenuHabit()" *ngIf="isRutas && 'Habit.Conduccion-R' | permissionFilter">
        <img src="/assets/img/icon_download_xls.png" width="25px">
        <span>Hábitos de Conducción</span>
      </button>
      <button #manejoR class="mat-button" mat-menu-item (click)="onClickReportMenuStats()" *ngIf="isRutas && 'Estad.Manejo-R' | permissionFilter">
        <img src="/assets/img/icon_download_xls.png" width="25px">
        <span>Estadisticos de Manejo</span>
      </button>
    </mat-menu>

    <!-- Menú secundario para geocercas-->
    <mat-menu #editAcciones="matMenu">
      <!-- Opciones para control llamado desde geocercas (ahora en el tool bar, pero aqui se ueden añadir otras accciones) -->
      <!-- <button #addGeofence *ngIf="!isGeofenceDetails && 'AgregarGeocerca' | permissionFilter" mat-menu-item (click)="onClickEditGeofence()">
       <img src="assets/images/icon_plus.png" style="width: 25px;">
        <span>Crear</span>
      </button>
      <button #editGeofence *ngIf="isGeofenceDetails && 'EditarGeocerca' | permissionFilter" mat-menu-item (click)="onClickEditGeofence()">
        <mat-icon>edit</mat-icon>
        <span>Editar</span>
      </button>
      <button #cloneGeofence *ngIf="isGeofenceDetails && 'DuplicarGeocerca' | permissionFilter" mat-menu-item (click)="onClickDuplicateGeofence()">
        <mat-icon>control_point_duplicate</mat-icon>
        <span>Duplicar</span>
      </button>
      <button #deleteGeofence *ngIf="isGeofenceDetails && 'BorrarGeocerca' | permissionFilter" mat-menu-item (click)="onClickDeleteGeofence()">
        <mat-icon>delete</mat-icon>
        <span>Borrar</span>
      </button> -->
    </mat-menu>

    <!-- Menú secundario para geoProcesos -->
    <mat-menu #menuGeoProcesos="matMenu">
      <button #geoPFrecuencyL class="mat-button" mat-menu-item (click)="openRecurrentPlaces()" *ngIf="isFromLocation && 'Lugares.Recurrentes-G' | permissionFilter">
        <!-- <img src="/assets/img/icon_download_xls.png" width="25px"> -->
        <span>Lugares frecuentes</span>
      </button>

    </mat-menu>

</div>